import React, { useEffect, useRef, useState } from "react";

import { connect } from 'react-redux';
import { FilterSelector } from '.';
import { filterSelectorState, filterDispatcher, repositoryState, combineStates, pageresultState, combineDispatchers, analyticsDispatcher,
  siteSettingsState, identityState, currentNodeState } from '../../../../store';
import { PropTypes } from 'prop-types';
import { SelectionViewer, SvgImage } from '../../../../components';
import { translate, getLanguages, localStore } from '../../../../services';
import { FilterIconNew, ResetSearchIconNew, SearchIconNew, searchIcon } from '../../../../../style/images';
import { TranslationService } from '../../../../util';
import { Badge, Box, Drawer, Icon } from '@mui/material';

const deadValues = ['not applicable', 'not&#032;applicable', 'do not display'];

const ConfiguratorSelectorViewerComponent = (props)=>{

    const [CustomerCode, setCustomerCode] = useState(null)
    const [filterCount, setFilterCount] = useState(0);

    const previousCurrentSelector = useRef(props.currentSelector);

    const updateCustomerCode = (customerCode) =>{
        setCustomerCode(customerCode);
    }

    const updateFilterCount = ()=>{

    }
    //on 1st render
    useEffect(()=>{
        const { currentSelector, filterSelectors, siteSettings, user } = props;
        let count = 0;
        if( siteSettings.filterBasedOnSelectorProperty && currentSelector ){
        currentSelector.sqlFilters ? currentSelector.sqlFilters : currentSelector.sqlFilters = [];
        currentSelector.sqlFilters.forEach((filter) =>{
            if(filter.property=='IsSelectorProduct.' + user.country){
            count+=1;}})
            if(count<0){
                
        currentSelector.sqlFilters.push({
            contains: null,
            equalsTo: "True",
            isUserDefined: false,
            property: "IsSelectorProduct." + user.country,
            startsWith: null
        });    
            }
            }
        ( (!filterSelectors || isRelatedFilterUpdated() ) && currentSelector || user.authenticationType === 'PartnerHub') && props.getFilterSelectors( currentSelector, user );
        updateCustomerCode(props.user.properties.CustomerCode);
        const totalSelectedFilters = filterSelectors?.filter( filter =>filter.properties.Show && !deadValues.includes(filter.name.toLocaleLowerCase( 'en-US' ))&&filter.values.any( v =>!deadValues.includes(v.name?.toLocaleLowerCase( 'en-US' )) && v.isSelected ) );
        totalSelectedFilters&&props.totalFilterCount!==totalSelectedFilters.length&&props.updateTotalFilterCount(totalSelectedFilters.length)
        },[]
    )

        //on update
    useEffect(()=>{
        const { currentSelector, filterSelectors, siteSettings, user } = props;
        const totalSelectedFilters = filterSelectors?.filter( filter =>filter.properties.Show && !deadValues.includes(filter.name.toLocaleLowerCase( 'en-US' ))&&filter.values.any( v =>!deadValues.includes(v.name?.toLocaleLowerCase( 'en-US' )) && v.isSelected ) );
        totalSelectedFilters&&props.totalFilterCount!==totalSelectedFilters.length&&props.updateTotalFilterCount(totalSelectedFilters.length)
        updateCustomerCode(props.user.properties.CustomerCode);
        props.setTotalItems(props.pageresult);
        },
    )
    
    useEffect(()=>{
        const { currentSelector, user } = props;
        localStore.set( 'isStockFilterSelected', false  );
        if ( currentSelector && previousCurrentSelector.current && currentSelector.name !== previousCurrentSelector.current.name ||( CustomerCode && props.user.properties.CustomerCode !== CustomerCode  ) ) {
        props.getFilterSelectors( currentSelector, user, true );
        }
    },[props.currentSelector])

    const isRelatedFilterUpdated = () => {
        const { filterSelectors, relatedFilterSelectors } = props;
        if( !relatedFilterSelectors ) {
          return false;
        }
    
        for( let relatedFilter of relatedFilterSelectors ) {
          for( let filter of filterSelectors ) {
            if( relatedFilter.identifier === filter.identifier ) {
              for( let relatedValue of relatedFilter.values ) {
                for( let value of filter.values ) {
                  if( value.name === relatedValue.name && value.isSelected !== relatedValue.isSelected ) {
                    return true;
                  }
                }
              }
            }
          }
        }
    
        return false;
      }

    const onFilterSelectorsChanged = (filterSelector) => {
        const { currentSelector, filterSelectors, user, pageresult } = props;
        const userSelectedFilters = filterSelectors.filter( filter => filter.isUserAssigned && filter.values.any( v => v.isSelected ) );
        userSelectedFilters.push( filterSelector );
        const totalSelectedFilters = filterSelectors.filter( filter => filter.properties.Show && !deadValues.includes(filter.name.toLocaleLowerCase( 'en-US' ))&& filter.values.any( v => !deadValues.includes(v.name?.toLocaleLowerCase( 'en-US' )) && v.isSelected ) );
        totalSelectedFilters.push( filterSelector );
        props.updateTotalFilterCount(totalSelectedFilters.length)
        props.updateFilterCount(userSelectedFilters.length)
        const userSelectedString = userSelectedFilters.reduce( ( concatenatedString, filter ) =>
          `${ concatenatedString }${ filter.name }$${ filter.values.filter( v => v.isSelected ).map( v => v.name ).join( '-' ) }#`, "" );
        props.captureEvent( "selectorSelection", currentSelector.name, userSelectedString, ['commonTracker'] );
        
        const trackSelector = {}
        userSelectedString.split("#").map((item)=>{
          if(item!==""){
            const selector = item.split("$");
            trackSelector[selector[0]] = selector[1];
          }  
        });
       
        //ga4
       
        dataLayer.push({
           'event': "selector_selection",
           event_action: currentSelector.name,
           event_label:userSelectedString,
           event_instance:props.siteSettings.properties.GaInstance,
           event_country: props.siteSettings.properties.GaCountry,
           location_url:window.location.href
        })
      
        return props.updateSelectedValue( filterSelectors, currentSelector, user, filterSelector, 0, pageresult.request.hasStockFilter );
      }

    const getTitleforHelpInamge = () => {
        const {currentNode, filterSelectors} = props;
        var title = '';
        if(filterSelectors && currentNode && currentNode.customProperties.customImageFilter){
            const filter = filterSelectors.firstOrDefault(f => f.fullyQualifiedName == currentNode.customProperties.customImageFilter);
            if(filter && filter.values.firstOrDefault(v => v.isSelected)){
              title = filter.values.firstOrDefault(v => v.isSelected).name;
            }
        }
    
        return title;
      }

    const { complexFilterComponents = [], currentSelector, filterSelectors, selectorName, looseAccessoryType4 } = props;
    const translationService = TranslationService( selectorName, 'selector' )( getLanguages().first() );
    const customeFilteImageTitle = getTitleforHelpInamge();
    // if(filterSelectors && !props.showResetHeader && this.setShowResetHeader && currentSelector.type !== 2){
    //   props.setShowResetHeader()
    // }

    const filters = filterSelectors && filterSelectors.map( translationService.withValues.bind( translationService ) ).map( ( item, index ) => 
    <FilterSelector 
      selectorName={ selectorName } 
      filter={ item }
      filterSelectors = { filterSelectors }
      key={ item.identifier + index } 
      onFilterSelectorsChanged={ onFilterSelectorsChanged }
      customeFilteImageTitle = {customeFilteImageTitle}
    /> 
  );
    return <>{ filters }</>
}

export const ConfiguratorSelectorViewer = name => connect( 
    combineStates( filterSelectorState( 'selector' )( name ), pageresultState( 'products' )( name ), repositoryState( 'selector' ), siteSettingsState, identityState, currentNodeState ), 
   combineDispatchers( filterDispatcher, analyticsDispatcher) 
  )( ConfiguratorSelectorViewerComponent );

